import FindControlViewState from '../store/schema/FindControlViewState';
import { FeedbackManagerState } from 'owa-feedback-manager/lib/store/schema/FeedbackManagerState';
import {
    FindResultType,
    DirectorySearchType,
} from 'owa-recipient-common/lib/store/schema/FindControlViewState';

export default function createFindControlViewState(
    queryString?: string,
    findPeopleFeedbackManager?: FeedbackManagerState,
    inForceResolve?: boolean
): FindControlViewState {
    let findControlViewState: FindControlViewState = {
        queryString: queryString ? queryString : '',
        shouldShowFindResult: false,
        findResultSet: [],
        findResultType: FindResultType.None,
        findResultHightlightIndex: -1,
        isSearching: false,
        directorySearchType: DirectorySearchType.None,
        findPeopleFeedbackManager: findPeopleFeedbackManager,
        inForceResolve: inForceResolve,
        currentRenderedQueryString: '',
    };

    return findControlViewState;
}
